var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card-header',{attrs:{"header-class":"editor-toolbar-collapse-header !h-[43px] transition-all d-flex align-items-center rounded-0"},on:{"mouseenter":function($event){_vm.menu = true},"mouseleave":function($event){_vm.menu = false}}},[_vm._t("default"),(_vm.menu)?_c('div',{staticClass:"ml-auto"},[_vm._t("menu")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }